"use client";

import { AlertTriangle } from "lucide-react";
import * as React from "react";
import { Button } from "../primitives/button";
import { cn } from "../lib/cn";

export interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  traceId?: string;
  className?: string;
}

export function ErrorState({
  title = "Something went wrong",
  description = "An unexpected error occurred. Try again, and if it persists, contact support with the trace id.",
  onRetry,
  retryLabel = "Retry",
  traceId,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-danger/40 bg-danger/10 p-12 text-center",
        className,
      )}
    >
      <AlertTriangle className="size-10 text-danger" aria-hidden="true" />
      <h3 className="text-lg font-semibold text-fg">{title}</h3>
      <p className="max-w-md text-sm text-fg-muted">{description}</p>
      {traceId ? (
        <p className="font-mono text-xs text-fg-muted">trace: {traceId}</p>
      ) : null}
      {onRetry ? (
        <Button variant="outline" onClick={onRetry} className="mt-2">
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}
